<template>
  <div class="main">
    <Header/>
    <div v-if="vip">
      <div class="card">
        金额：<span style="color: red">{{ vip.presentPrice }}元</span> (共{{ number() }}天VIP)
      </div>
      <div class="card">
        <span style="font-size: 14px;text-align: center;display: block">请选择支付方式</span>
        <div class="pay-mode">
          <el-radio v-model="payWay" label="JuZiPay">网页支付</el-radio>
        </div>
      </div>
      <div class="card">
        <el-button type="primary" style="width: 100%;" @click="onPay">立即支付</el-button>
      </div>
      <div class="desc">
                {{tips()}}无法安装的{{us()}}
      </div>
    </div>
    <ContactUs/>
  </div>
</template>

<script>
import Header from '@/components/Header';
import ContactUs from "../components/contact-us";
import {Loading} from 'element-ui';
import WebConfig from "../lib/web.config";

export default {
  name: "recharge",
  components: {
    Header,
    ContactUs,
  },
  data() {
    return {
      // Vip套餐对象
      vip: undefined,
      // 单选
      payWay: "JuZiPay",
    };
  },
  created() {
    // 加载充值套餐
    let loadingInstance = Loading.service({});
    this.$axios.post(`/api/user/account/vip/queryDownloadVipCost`).then((res) => {
      if (res.code === 200) {
        this.$data.vip = res.data;
      }
    }).finally(() => loadingInstance.close());
  },
  methods: {
    // 充值按钮点击事件
    onPay() {
      location.href = `${WebConfig.apiUrl}/user/pay/generateOrder?payWay=${this.$data.payWay}&type=VIP&token=${sessionStorage.getItem("Token")}&vipCostId=${this.$data.vip.id}&callbackUrl=${WebConfig.webUrl}/open`;
    },
    // 获得充值数量
    number() {
      return this.$data.vip.day + (this.$data.vip.give ?? 0);
    },
    // 联系方式文本
    us() {
      return JSON.parse(localStorage.getItem("Config"))["Web_Contact_Info"];
    },
    // 提示信息
    tips() {
      return JSON.parse(localStorage.getItem("Config"))["Web_Recharge_Tips"];
    }
  },
}
</script>

<style scoped>
.main {
  background: #f5f5f5;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
}

.card {
  background: #FFF;
  margin: 10px 0;
  padding: 10px;
}

.pay-mode {
  margin-top: 10px;
}

.desc {
  color: #ccc;
  font-size: 14px;
  padding: 10px;
}
</style>
